const statementsReducer = (state, { payload, type }) => {
    switch (type) {
        case 'ACCOUNTS_UPDATED':
            return {
                ...payload,
            };
        case 'FETCH_INIT':
            return {
                ...state,
                [payload.accountNumber]: {
                    ...state[payload.accountNumber],
                    isFetchingStatements: true,
                },
            };
        case 'FETCH_SUCCESS':
            return {
                ...state,
                [payload.accountNumber]: {
                    ...state[payload.accountNumber],
                    isFetchingStatements: false,
                    listOfStatements: payload.listOfStatements,
                },
            };
        case 'FETCH_FAILURE':
            return {
                ...state,
                [payload.accountNumber]: {
                    ...state[payload.accountNumber],
                    error: payload.error,
                    isFetchingStatements: false,
                },
            };
        default:
            throw new Error();
    }
};

export default statementsReducer;
